'use client';

import styled from 'styled-components';

// --------------------------------------------------------------------------

const Tooltip = styled.div<{ $visible?: boolean }>`
  position: fixed;
  z-index: 999;
  bottom: 0;
  left: 0;
  background-color: white;
  font-size: 0.325rem;
  padding: 0.25rem;
  pointer-events: none;
  display: ${(p) => (p.$visible ? 'block' : 'none')};
`;

// --------------------------------------------------------------------------

export const PageInfo = ({
  source,
}: {
  source?: {
    env?: string;
    id?: string | null;
    path?: string | null;
    fallback?: string;
  };
}) => {
  if (!source) {
    return null;
  }
  return (
    <Tooltip
      $visible={process.env['NEXT_PUBLIC_ALLOW_PAGE_INFO'] === 'true'}
      aria-hidden
    >
      {!!source?.env && <div>ENV: {source?.env}</div>}
      {!!source?.id && <div>ID: {source?.id}</div>}
      {!!source?.path && <div>PATH: {source?.path}</div>}
      {!!source?.fallback && <div>FALLBACK: {source.fallback}</div>}
    </Tooltip>
  );
};
